<template>
    <div v-if="success" class="mt-2 mb-4">
        <div v-if="request.isWithdrawal">
            Vaša žiadosť o výber peňažných prostriedkov bola odoslaná na spracovanie.<br>
            O jej výsledku Vás budeme informovať.
        </div>
        <div v-else>
            Žiadosť o vklad finančných prostriedkov bol úspešne odoslaný.<br><br>
            Vklad peňažných prostriedkov zrealizujte na zberný účet vedený v ČSOB - {{iban[request.currency]}} spolu s variabilným symbolom {{request.portfolio}}.
        </div>
    </div>
    <form v-else class="request-wrapper" @submit.prevent="addNewWithdrawalRequest()">
        <div class="row">
            <div class="col-12 col-md-5">
                <div class="row">
                    <b-form-group>
                        <b-form-radio-group
                            v-model="request.isWithdrawal"
                            :options="options"
                            buttons
                            button-variant="outline-primary"
                            size="sm"
                            name="radio-btn-outline"
                        ></b-form-radio-group>
                    </b-form-group>
                </div>
                <div class="row">
                    <div class="col-4">Portfólio:</div>
                    <select class="col-8 form-control" v-model="request.portfolio" required>
                        <option value="default"></option>
                        <option v-for="portfolio in portfolios" v-bind:value="portfolio.portfolio">{{portfolio.portfolio}}</option>
                    </select>
                </div>
                <div class="row">
                    <div class="col-4">Mena:</div>
                    <select class="col-8 form-control" v-model="request.currency" required>
                        <option value="default"></option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                        <option value="CZK">CZK</option>
                        <option value="GBP">GBP</option>
                        <option value="TRY">TRY</option>
                        <option value="NOK">NOK</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-6 ml-md-4">
                <div class="row">
                    <div class="col-4">Suma:</div>
                    <input class="col-8 form-control" type='number'
                        v-model="request.price" required
                    />
                </div>
                <div class="row">
                    <div class="col-4">Poznámka:</div>
                    <textarea class="col-8 form-control" 
                        v-model="request.message"
                    />
                </div>
                <div class="row">
                    <input class="form-control col-5 col-md-5 pin-input" type='text'
                           v-model="verification.code" placeholder="Zadajte SMS kód" required
                    />
                    <button class="btn btn-dark btn-sm offset-1 col-6 col-md-6" @click="sendPin()">Zaslať SMS kód</button>
                </div>
                <div class="row float-right">
                    <button type="submit" class="btn btn-primary btn-sm w-20">Odoslať</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "TradeForm",
        created() {
            this.loadData();
        },
        computed: {
            portfolios() {
                return this.$store.state.portfolio.items;
            },
        },
        methods: {
            addNewWithdrawalRequest() {
                this.$store.dispatch('account/activate', this.verification).then(() => {
                    this.$store.dispatch('account/newTransactionRequest', this.request).then((response) => {
                        this.success = true;
                    });
                });
            },
            loadData() {
                this.$store.dispatch("portfolio/portfolios");
            },
            sendPin() {
                this.$store.dispatch('account/sendPinCodeAgain')
            },
        },
        data() {
            return {
                request: { isWithdrawal: true },
                verification: {
                    code: '',
                    remember: true,
                },
                options: [
                    { text: 'VKLAD', value: false },
                    { text: 'VÝBER', value: true }
                ],
                success: false,
                iban: {
                    EUR: 'SK40 7500 0000 0001 5580 1793',
                    USD: 'SK67 7500 1764 0101 5579 9873',
                    CZK: 'SK69 7500 1769 1101 5579 9873',
                    GBP: 'SK22 7500 1760 8101 5579 9873',
                    TRY: 'SK44 7500 1729 6101 5579 9873',
                    NOK: 'SK13 7500 1751 5002 5510 1583'
                }
            }
        }
    }
</script>